module.exports = __webpack_public_path__ + "img/dummyprod9@1x.f0e59627.png";